import paths from 'constants/paths';
const { allArticlesPage, categoryHome } = paths;
import { fetchCategoriesForNavigation } from 'data/CategoryPage/data';
import { NavItemType } from './types';

const fetchNavigationItems = async (): Promise<NavItemType[]> => {
  const categoriesForNav = await fetchCategoriesForNavigation();

  const navigationItems = [
    { href: paths.basePath, text: 'Home', submenu: [] },
    ...categoriesForNav.map((category) => ({
      href: '',
      text: category.title ?? '',
      submenu: [
        {
          href: categoryHome(category.slug!),
          text: 'All articles',
        },
        ...category.children.map((child) => ({
          href: allArticlesPage(child.slug!),
          text: child.title ?? '',
        })),
      ],
    })),
    {
      href: '/learn',
      text: 'Learning center',
      submenu: [],
    },
    {
      href: '/blog/updates',
      text: 'Zapier updates',
      submenu: [],
    },
  ];

  return navigationItems;
};

export default fetchNavigationItems;
